import { render, staticRenderFns } from "./Ktop.vue?vue&type=template&id=9b6fe6d0&"
import script from "./Ktop.vue?vue&type=script&lang=js&"
export * from "./Ktop.vue?vue&type=script&lang=js&"
import style0 from "./Ktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports